// extracted by mini-css-extract-plugin
export default {"header":"qM","discountBanner":"rM","logo":"sM","maincontainer":"tM","videocontainer":"uM","videowelcome":"vM","videowrapper":"wM","videosale":"xM","loadingcontainer":"yM","footer":"zM","footerbutton":"AM","video":"BM","logoname":"CM"};
    if(module.hot) {
      // 1715276859009
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  